"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var airguitarEgg = {
    name: "airguitar",
    enabled: false,
    trigger: {
        type: "keys",
        keystrokes: ["a", "i", "r", "g", "u", "i", "t", "a", "r"],
        captureOnInputs: false
    },
    onStart: function () {
        var data = "https://i.imgur.com/VZoOYz4.gif";
        var shock = document.createElement("div");
        var img = new Image();
        img.src = data;
        img.style.width = "450px";
        img.style.height = "320px";
        img.style.transition = "1s all";
        img.style.position = "fixed";
        img.style.left = "calc(50% - 225px)";
        img.style.bottom = "-260px";
        img.style.zIndex = "999999";
        document.body.appendChild(img);
        window.setTimeout(function () {
            img.style.bottom = "-30px";
        }, 50);
        window.setTimeout(function () {
            img.style.bottom = "-300px";
        }, 4300);
        window.setTimeout(function () {
            img.parentNode.removeChild(img);
            shock.parentNode.removeChild(shock);
        }, 5400);
    },
};
exports.default = airguitarEgg;
